import { P2, h1, h2, h3, h4, h5 } from '@repo/ui/components/Typography';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { FlexRow } from 'styles/layouts';

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  gap: 24px;
  text-align: center;

  ${QUERIES.tabletAndUp} {
    grid-template-columns: ${({ imageOnTheRight }) =>
      imageOnTheRight ? '2fr 3fr' : '3fr 2fr'};
    gap: 32px;
    text-align: left;
  }

  ${QUERIES.laptopAndUp} {
    gap: 64px;
  }
`;

export const ButtonsWrapper = styled(FlexRow)`
  gap: 12px;
  flex-wrap: wrap;
  align-self: center;

  ${QUERIES.tabletAndUp} {
    align-self: flex-start;
  }
`;

export const ImageContainer = styled.div`
  width: 100%;
  border-radius: ${themeStyle.radiusLarge};

  img,
  video {
    display: block;
    max-width: 100%;
    max-height: 480px;
    border-radius: ${themeStyle.radiusLarge};
    overflow: hidden;
  }
`;

export const TextWrapper = styled(P2)`
  p {
    min-height: 1em;
  }

  p,
  ul,
  ol {
    margin: 0;
  }

  ul,
  ol {
    padding-left: 22px;
  }

  li + li {
    margin-top: 12px;
  }

  margin-bottom: 24px;

  p + p,
  ol + ol,
  ul + ul {
    margin-top: 24px;
  }

  b {
    font-weight: ${themeStyle.fontBold};
  }

  h1 {
    ${h1}
  }
  h2 {
    ${h2}
  }
  h3 {
    ${h3}
  }
  h4 {
    ${h4}
  }
  h5 {
    ${h5}
  }
  h1,
  h2,
  h3,
  h4,
  h5 {
    margin: 0;
    margin-bottom: 12px;
  }

  a {
    cursor: pointer;
    text-decoration: underline;
  }

  margin-bottom: ${({ hasButtons }) => (hasButtons ? '24px' : '0px')};

  ${QUERIES.largeTabletAndUp} {
    margin-bottom: ${({ hasButtons }) => (hasButtons ? '48px' : '0px')};
  }
`;
